import { render, staticRenderFns } from "./ImportantReminders.vue?vue&type=template&id=49358247"
import script from "./ImportantReminders.vue?vue&type=script&lang=js"
export * from "./ImportantReminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports